/* ODD HAND – portrait option blocks. Builds colour swatches from the Portrait colour metaobjects,
   drives the live heart preview and the Yes/No text boxes. */
(function () {
  if (window.__ohPortraitOptions) return;
  window.__ohPortraitOptions = true;

  // Built-in looks for patterns that don't have a pattern image uploaded yet.
  var PATTERNS = {
    'leopard': 'radial-gradient(circle at 30% 30%, #3a2a14 16%, transparent 18%) 0 0/14px 14px, radial-gradient(circle at 70% 70%, #3a2a14 13%, transparent 15%) 0 0/14px 14px, #e9a94a',
    'polka dot': 'radial-gradient(#333 22%, transparent 24%) 0 0/9px 9px, #efc6c4',
    'cow print': 'radial-gradient(circle at 30% 35%, #111 20%, transparent 22%) 0 0/22px 22px, radial-gradient(circle at 75% 75%, #111 14%, transparent 16%) 0 0/22px 22px, #efe7d4',
    'tiger': 'repeating-linear-gradient(60deg, #e86a12 0 6px, #1a1a1a 6px 9px)',
    'stars': 'radial-gradient(#2c5c89 25%, transparent 27%) 0 0/10px 10px, #d82126',
    'stripes': 'repeating-linear-gradient(90deg, #016848 0 5px, #e68e95 5px 10px)'
  };

  function bgFor(c, tile) {
    if (!c) return null;
    if (c.img) return 'url("' + c.img + '") center/' + (tile || 'cover') + ' repeat, ' + (c.hex || '#ccc');
    var p = PATTERNS[(c.name || '').toLowerCase()];
    return p || c.hex;
  }
  function labelFor(c, numbers) {
    if (numbers === false) return c.name;
    return (c.n < 10 ? '0' + c.n : c.n) + ' · ' + c.name;
  }
  function list(str) {
    return (str || '').split(',').map(function (x) { return x.trim().toLowerCase(); }).filter(Boolean);
  }

  var state = {}; // state[sectionId][role] = colour object or {surprise:true,label}

  function updatePreviews(sectionId) {
    document.querySelectorAll('[data-oh-colour-preview][data-section="' + sectionId + '"]').forEach(function (prev) {
      var s = state[sectionId] || {};
      var h = s.heart, b = s.background;
      var heartEl = prev.querySelector('[data-prev-heart]');
      var bgEl = prev.querySelector('[data-prev-bg]');
      heartEl.style.background = (h && !h.surprise) ? bgFor(h, '26px') : prev.dataset.defaultHeart;
      bgEl.style.background = (b && !b.surprise) ? bgFor(b, '34px') : prev.dataset.defaultBg;
      var cap = prev.querySelector('[data-prev-caption]');
      if (cap) {
        var nums = prev.dataset.numbers !== 'false';
        var choice = prev.dataset.choiceText || "Han's choice";
        cap.textContent = 'Heart: ' + (h && !h.surprise ? labelFor(h, nums) : choice) + '  /  Background: ' + (b && !b.surprise ? labelFor(b, nums) : choice);
      }
    });
  }

  function buildPicker(el) {
    if (el.dataset.ready) return;
    el.dataset.ready = '1';
    var colours = [];
    try { colours = JSON.parse(el.querySelector('[data-colours]').textContent); } catch (e) {}
    colours.sort(function (a, b) { return a.n - b.n; });
    var wrap = el.querySelector('[data-swatches]');
    var chosen = el.querySelector('[data-chosen]');
    var name = 'properties[' + el.dataset.prop + ']';
    var form = el.dataset.form;
    var sectionId = el.dataset.section;
    var role = el.dataset.role;
    var required = el.dataset.required === 'true';
    var surprise = el.dataset.surprise;
    var showGroups = el.dataset.groups === 'true';
    var headingGroups = list(el.dataset.groupHeadings);   // groups that get their own heading
    var onlyGroups = list(el.dataset.onlyGroups);         // if set, only show these groups
    var numbers = el.dataset.numbers !== 'false';
    state[sectionId] = state[sectionId] || {};

    if (onlyGroups.length) {
      colours = colours.filter(function (c) { return onlyGroups.indexOf((c.group || '').toLowerCase()) > -1; });
    }

    function add(value, dotStyle, title, data, isSurprise) {
      var lab = document.createElement('label');
      lab.className = 'oh-swatch';
      lab.title = title;
      var inp = document.createElement('input');
      inp.type = 'radio'; inp.name = name; inp.value = value;
      if (form) inp.setAttribute('form', form);
      if (required) inp.required = true;
      inp.setAttribute('aria-label', title);
      var dot = document.createElement('span');
      dot.className = 'oh-swatch__dot' + (isSurprise ? ' oh-swatch__dot--surprise' : '');
      if (dotStyle) dot.style.background = dotStyle;
      lab.appendChild(inp); lab.appendChild(dot);
      inp.addEventListener('change', function () {
        chosen.textContent = title;
        state[sectionId][role] = data;
        updatePreviews(sectionId);
      });
      wrap.appendChild(lab);
      return inp;
    }

    if (surprise) {
      var s = add(surprise, null, surprise, { surprise: true }, true);
      s.checked = true;
      chosen.textContent = surprise;
      state[sectionId][role] = { surprise: true };
    }

    // Colours whose group has no heading are shown together, in chart-number order.
    // Groups listed in "Groups with their own heading" are moved to the end under a heading.
    var main = [], grouped = {};
    colours.forEach(function (c) {
      var g = (c.group || '').toLowerCase();
      if (showGroups && headingGroups.indexOf(g) > -1) {
        if (!grouped[g]) grouped[g] = [];
        grouped[g].push(c);
      } else {
        main.push(c);
      }
    });
    main.forEach(function (c) { add(labelFor(c), bgFor(c, 'cover'), labelFor(c, numbers), c, false); });
    headingGroups.forEach(function (g) {
      if (!grouped[g]) return;
      var h = document.createElement('span');
      h.className = 'oh-swatches__group';
      h.textContent = grouped[g][0].group;
      wrap.appendChild(h);
      grouped[g].forEach(function (c) { add(labelFor(c), bgFor(c, 'cover'), labelFor(c, numbers), c, false); });
    });
    updatePreviews(sectionId);
  }

  function buildYesNo(el) {
    if (el.dataset.ready) return;
    el.dataset.ready = '1';
    var more = el.querySelector('[data-yn-more]');
    var input = el.querySelector('[data-yn-input]');
    var req = el.dataset.required === 'true';
    function sync() {
      var yes = el.querySelector('[data-yn-yes]').checked;
      more.hidden = !yes;
      input.disabled = !yes;           // disabled = not sent with the order
      input.required = yes && req;
      if (yes) input.focus({ preventScroll: true });
    }
    el.querySelectorAll('input[type=radio]').forEach(function (r) { r.addEventListener('change', sync); });
  }

  // Move the "Odd Hand portrait options" section into the product info column and
  // connect its answers to the Add to cart form.
  function findForm() {
    return document.querySelector('product-form form[data-type="add-to-cart-form"]') ||
           document.querySelector('form[id^="product-form-"][action*="/cart/add"]');
  }
  function relocate(sec) {
    var form = findForm();
    if (!form) return;
    sec.querySelectorAll('[data-oh-colour-picker]').forEach(function (p) { p.dataset.form = form.getAttribute('id'); });
    if (sec.dataset.placement === 'in_place' || sec.dataset.moved) return;
    var info = form.closest('.product__info-container') || document;
    var buyBlock = form.closest('product-form') ? form.closest('product-form').parentElement : null;
    var target = null, after = false;
    if (sec.dataset.placement === 'after_variants') {
      target = info.querySelector('variant-selects, variant-radios');
      after = !!target;
      if (!target) target = info.querySelector('.product-form__quantity');
    }
    if (!target) { target = buyBlock; after = false; }
    if (!target) return;
    // remove a stale copy left behind after the theme editor reloads the section
    document.querySelectorAll('[data-oh-portrait-section][data-section-id="' + sec.dataset.sectionId + '"][data-moved]').forEach(function (old) { if (old !== sec) old.remove(); });
    if (after) target.insertAdjacentElement('afterend', sec); else target.insertAdjacentElement('beforebegin', sec);
    sec.dataset.moved = '1';
    keepAboveApps(sec);
  }
  // Keep these questions above the product-options app's form (it loads a little later).
  function keepAboveApps(sec) {
    if (sec.dataset.placement !== 'after_variants') return;
    var v = sec.parentElement && sec.parentElement.querySelector('variant-selects, variant-radios');
    if (!v) return;
    var n = v.nextElementSibling;
    while (n && n !== sec && n.tagName === 'GPO-CONTAINER') {
      n.insertAdjacentElement('beforebegin', sec);
      n = v.nextElementSibling;
    }
  }
  function attachInputs(sec) {
    var form = findForm();
    if (!form) return;
    sec.querySelectorAll('input[name^="properties["], textarea[name^="properties["]').forEach(function (i) { i.setAttribute('form', form.getAttribute('id')); });
    if (!form.dataset.ohClean) {
      form.dataset.ohClean = '1';
      // Don't send unanswered questions with the order
      form.addEventListener('formdata', function (e) {
        Array.from(e.formData.entries()).forEach(function (pair) {
          if (pair[0].indexOf('properties[') === 0 && typeof pair[1] === 'string' && pair[1].trim() === '') e.formData.delete(pair[0]);
        });
      });
    }
  }

  function init(root) {
    var secs = document.querySelectorAll('[data-oh-portrait-section]');
    secs.forEach(relocate);
    (root || document).querySelectorAll('[data-oh-colour-picker]').forEach(buildPicker);
    (root || document).querySelectorAll('[data-oh-yesno]').forEach(buildYesNo);
    secs.forEach(attachInputs);
    document.querySelectorAll('[data-oh-colour-preview]').forEach(function (p) { updatePreviews(p.dataset.section); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  function recheck() { document.querySelectorAll('[data-oh-portrait-section][data-moved]').forEach(keepAboveApps); }
  window.addEventListener('load', recheck);
  setTimeout(recheck, 1500);
  setTimeout(recheck, 4000);
  // Re-run when edited in the theme editor
  document.addEventListener('shopify:section:load', function () { init(); });
  document.addEventListener('shopify:block:select', function () { init(); });
})();
